import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.css'],
})
export class PaymentSummaryComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  toggleMobileNav() {
    const mobileNav = document.getElementById('navbarNav');
    mobileNav?.classList.toggle('d-none');
  }
}
